import React,
{
  useState,
  useEffect,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import OpenIcon from '@learningblocks/exp-constants/lib/Icons/chevron-down-solid';
import './style.scss';

const ENTER_KEY = 13;

export function ContentDropdown(props) {
  
const ref = useRef();

const [open, setOpen] = useState(props.open);
const [contentHeight, setContentHeight] = useState("none");

useEffect(()=>{
  updateContentHeight();

  window.onresize = function() {
    updateContentHeight();
  };
}, []);

const updateContentHeight = () => {
  if(ref.current){
    setContentHeight(ref.current.scrollHeight + (!open ? 16 : 0));
  }
};

const toggleOpen = () => {
  updateContentHeight();
  setOpen(!open);
};

  return (
    <div
      className="ContentDropdown_container"
    >
      <div 
        className="ContentDropdown_btn"
        role="checkbox"
        aria-checked={open}
        tabIndex="0"
        aria-label={`Expand the \"${props.contentDetails.label !== undefined ? props.contentDetails.label : "Dropdown"}\" section.`} 
        onClick={()=>toggleOpen()}
        onKeyDown={(e)=>{
          if(e.keyCode === ENTER_KEY){
            toggleOpen()
          }
        }}
      >
        {props.contentDetails.label === undefined ? open ? "Collapse" : "Expand" : props.contentDetails.label}
        <OpenIcon 
          className={`ContentDropdown_icon ${open ? "open" : "closed"}`}
          alt="" 
        />
      </div>
      <div
        ref={ref}
        className={`ContentDropdown_content ${open ? "open" : "closed"}`}
        aria-hidden={!open}
        style={{
          maxHeight: open ? contentHeight : "0px"
        }}
      >
        {parse(props.contentDetails.content)}
      </div>
    </div>
  );
}

ContentDropdown.propTypes = {
  contentDropdown: PropTypes.shape({
    /**
     * Label that is displayed as the header for the Dropdown
     */
    label: PropTypes.string,
    /**
     * Content that is given to the particular dropdown.
     */
    content: PropTypes.string.isRequired,
    /**
     * Boolean that is used to check whether the dropdown is open or closed
     */
    open: PropTypes.bool.isRequired,
  }),
  id: PropTypes.number.isRequired,
};

ContentDropdown.defaultProps = {
  contentDropdown: null,
};
